<scaffold-dialog
  [showCloseButton]="showCloseButton"
  (close)="handleClick('')"
  [title]="title"
  [fit]="fit"
  [fullHeight]="fullHeight"
  size=""
>
  <div scaffoldDialogBody>
    <p *ngIf="text">{{ text }}</p>
  </div>
  <div scaffoldDialogButtons>
    <ng-container *ngFor="let option of options">
      <button
        nbButton
        [status]="option.status"
        (click)="handleClick(option.action)"
      >
        {{ option.text }}
      </button>
    </ng-container>
  </div>
</scaffold-dialog>
